/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

import { mime_type, Resource, WatchVideoConditionalProps } from '../types';

const loadResources = createAction('[Resource Page] load resources');

const onLoadResourceSuccess = createAction(
  '[Resource Page] load resources success',
  props<{
    resource: Resource[];
  }>(),
);

const onLoadResourceFailure = createAction(
  '[Resource Page] load resources failure',
  props<{
    error: Error;
  }>(),
);

const downloadResource = createAction(
  '[Resource Page] download resource',
  props<{
    mime_type: mime_type;
    uuid: string;
    conditionalProps: WatchVideoConditionalProps | null;
  }>(),
);

const onDownloadResourceSuccess = createAction(
  '[Resource Page] download resource success',
  props<{
    mime_type: mime_type;
    downloadString: string;
    conditionalProps: WatchVideoConditionalProps | null;
  }>(),
);

const onDownloadResourceFailure = createAction(
  '[Resource Page] download resource failure',
  props<{
    error: Error;
  }>(),
);

export const RESOURCE_PAGE_ACTIONS = {
  downloadResource,
  loadResources,
  onDownloadResourceFailure,
  onDownloadResourceSuccess,
  onLoadResourceFailure,
  onLoadResourceSuccess,
};
